import analytics from '@tkww/orion-web-legacy-union--tk-analytics';

const trackSegment = ({
  eventName = 'Registry Interaction',
  source = 'checklist',
  ...rest
}) => {
  analytics.track(eventName, {
    platform: 'web',
    product: 'your registry',
    source,
    ...rest,
  });
};

export const trackGroup = ({name}) =>
  trackSegment({
    selection: 'browse group',
    checklistGroup: name,
    userDecisionArea: 'group nav',
  });

export default trackSegment;
